/**
 * Helper condivisi per il corpo degli articoli del blog.
 * toHtml: converte il contenuto legacy (testo con paragrafi separati da riga vuota) in HTML.
 * sanitizePastedHtml: normalizza l'HTML incollato (Word, Google Docs, web) mantenendo SOLO
 * grassetto, corsivo, titoli, elenchi, link e citazioni; rimuove font/span/stili inline estranei.
 * Le dimensioni font scelte intenzionalmente dalla toolbar dell'editor (<font size>) non
 * passano dal copia-incolla: vengono create solo dalla toolbar e sopravvivono al salvataggio.
 */

export const toHtml = (content) =>
  (content || "").trim().startsWith("<")
    ? content
    : (content || "").split(/\n\n+/).filter(Boolean).map((p) => `<p>${p.replace(/\n/g, "<br/>")}</p>`).join("");

const ALLOWED = new Set(["P", "BR", "H2", "H3", "STRONG", "B", "EM", "I", "UL", "OL", "LI", "BLOCKQUOTE"]);

const escapeText = (t) => t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function sanitizePastedHtml(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const walk = (node) => {
    const out = [];
    for (const child of node.childNodes) {
      if (child.nodeType === 3) { out.push(escapeText(child.textContent)); continue; }
      if (child.nodeType !== 1) continue;
      const tag = child.tagName;
      if (tag === "SCRIPT" || tag === "STYLE" || tag === "META" || tag === "LINK") continue;
      const inner = walk(child).join("");
      if (tag === "BR") { out.push("<br/>"); continue; }
      if (tag === "DIV") { out.push(inner.trim() ? `<p>${inner}</p>` : ""); continue; }
      if (tag === "H1" || tag === "H4" || tag === "H5" || tag === "H6") { out.push(inner.trim() ? `<h2>${inner}</h2>` : ""); continue; }
      if (tag === "A") {
        const href = child.getAttribute("href") || "";
        out.push(/^https?:\/\//i.test(href) ? `<a href="${href.replace(/"/g, "&quot;")}" target="_blank" rel="noopener noreferrer">${inner}</a>` : inner);
        continue;
      }
      if (tag === "IMG") continue; // le immagini si inseriscono dalla toolbar (upload su storage)
      if (ALLOWED.has(tag)) { out.push(`<${tag.toLowerCase()}>${inner}</${tag.toLowerCase()}>`); continue; }
      out.push(inner); // unwrap: font, span, u, small, big, mark, o:p ecc.
    }
    return out;
  };
  return walk(doc.body).join("");
}

export function plainTextToParagraphs(text) {
  return (text || "")
    .split(/\n{2,}/)
    .filter(Boolean)
    .map((p) => `<p>${escapeText(p).replace(/\n/g, "<br/>")}</p>`)
    .join("");
}
